export default __webpack_public_path__ + "static/media/header-exam-active-icon.a57d431f.svg";